module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE3IiB2aWV3Qm94PSIwIDAgMTMgMTciIHdpZHRoPSIxMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDA3M0MyIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0wIDBoNHYxN2gtNHoiLz48cGF0aCBkPSJtOSAwaDR2MTdoLTR6Ii8+PC9nPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-pause.svg
// module id = 467
// module chunks = 0